export const formatAddressObject = (address) => {
  if (!address) return "N/A";

  if (address?.fullAddress) {
    return address?.fullAddress;
  }
  const streetPart = street ? street : "";

  const { street, city, state, zip } = address;

  return (
    `${streetPart}${streetPart ? ", " : ""}${city ? city : ""}${
      city ? ", " : ""
    }${state ? state : ""}${zip ? " " + zip : ""}`.trim() || "N/A"
  );
};
